import { render, staticRenderFns } from "./HolidayCalendar.vue?vue&type=template&id=0071852f&scoped=true"
import script from "./HolidayCalendar.vue?vue&type=script&lang=ts"
export * from "./HolidayCalendar.vue?vue&type=script&lang=ts"
import style0 from "./HolidayCalendar.vue?vue&type=style&index=0&id=0071852f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071852f",
  null
  
)

export default component.exports